export interface NoticeSummary {
  id: Id;
  title: Title;
  createdAt: Time;
}

export interface Notice extends NoticeSummary {
  content: TextContent;
  images: Image[];
}

export interface NoticeDto {
  id: Id;
  title: Title;
  contents?: TextContent;
  createdAt: DateString;
  imageUris?: Image[];
}

export const noticeSummaryFromDto = (noticeDto: NoticeDto): NoticeSummary => {
  return {
    id: noticeDto.id,
    title: noticeDto.title,
    createdAt: new Date(noticeDto.createdAt),
  };
};

export const noticeFromDto = (noticeDto: NoticeDto): Notice => {
  return {
    id: noticeDto.id,
    title: noticeDto.title,
    createdAt: new Date(noticeDto.createdAt),
    content: noticeDto.contents ?? '',
    images: noticeDto.imageUris ?? [],
  };
};
